export default __webpack_public_path__ + "static/media/bg.ed4145bf.jpg";